import React, { useMemo } from "react";
import PageLastUpdated from "../../../components/shared/PageLastUpdated";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useGetProtectedApiDataQuery } from "../../../redux/services/apiSlice";
import {
  convertStringToArray,
  extractDateFromStr,
  getLatestUpdatedObject,
  sanitizeString,
} from "../../../Utils/utils";
import usePagination from "../../../hooks/usePagination";
import Loader from "../../../components/Loader";
import { imageUrl } from "../../../constants/constants";
import Pagination from "../../../components/Pagination/Pagination";

const EventsDetail = () => {
  const { languageType } = useSelector((state) => state.homeSlice);
  const navigate = useNavigate();
  const {
    data: eventsData = [],
    error: eventsError,
    isLoading: eventsIsLoading,
  } = useGetProtectedApiDataQuery({ url: "event", lang: languageType });

  const lastUpdatedOn = useMemo(() => {
    return extractDateFromStr(getLatestUpdatedObject(eventsData)?.changed);
  }, [eventsData]);

  const transformedData = useMemo(() => {
    return eventsData.map((item) => ({
      ...item,
      field_upload_image: convertStringToArray(item.field_upload_image),
    }));
  }, [eventsData]);

  const { currentItems, currentPage, totalPages, handlePageChange } =
    usePagination(transformedData, 12);

  if (eventsError) {
    return <div>Failed to load news. Please try again later.</div>;
  }

  if (eventsIsLoading) return <Loader />;

  return (
    <>
      <div className="row events-sec innerevent">
        <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
        {currentItems.map((item, index) => (
          <div className="col-12 col-sm-12 col-md-3 col-lg-3" key={index}>
            {/* <EventCard selectedEvent={item} photoSlider={false} /> */}
            <div
              className="card-sec"
              key={index}
              onClick={() => {
                navigate(`/events-detail/${item.nid}`);
              }}
            >
              <div className="img-sec">
                <img
                  src={
                    item?.field_upload_image?.[0]?.file_path
                      ? imageUrl + item.field_upload_image[0].file_path
                      : "images/dummy.png"
                  }
                  alt={item.title}
                />
              </div>
              <div className="desc-sec">
                {item.field_ordering_date && (
                  <span className="date">{item.field_ordering_date}</span>
                )}
                <p>{sanitizeString(item.title)}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />
    </>
  );
};

export default EventsDetail;
